<template>
  <div>
    <list row-key="DocProductId" ref="list" unit="生产报工" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="api.ProductList" :reset-data-func="resetDataFunc" @expand-change="expandChange" resetCustomQuary
      @resetQuery="resetQuery">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商" label-width="120px">
          <el-select style="width: 180px" @change="changeTradeUnit" filterable v-model="params.TradeUnitId">
            <el-option v-for="item in tradeUnitList" :key="item.key" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="params.DocDateStart" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
          -
          <el-date-picker v-model="params.DocDateEnd" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品名称" prop="ClassNo">
          <el-input v-model="params.ProductName" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" >
            <el-option label="未处理" :value="1" key="a1"></el-option>
            <el-option label="已处理" :value="2" key="a2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报工人" prop="ClassNo">
          <el-input v-model="params.MakeEmpName" placeholder="请输入报工人"></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table key="table1" :data="scope.row.listData" border>
              <!-- <el-table-column type="index" label="序号" min-width="55" align="left" /> -->
              <el-table-column prop="PuDocDate" label="采购订单日期" min-width="120px" >
                <template slot-scope="{row}">{{$commonJs.toDateString(row.PuDocDate)}}</template>
              </el-table-column>
              <el-table-column prop="SourceNo" label="单号" min-width="120px" />
              <el-table-column prop="TradeUnitName" label="供应商" min-width="120px" />
              <el-table-column prop="ProductNo" label="存货编码" min-width="120px" align="right" />
              <el-table-column prop="ProductName" label="存货名称" min-width="120px" align="right" />
              <el-table-column prop="PuDocQuantity" label="订单数量" min-width="120px" align="right" />
              <el-table-column prop="WaitPuDocQuantity" label="待入库数" min-width="120px" align="right" />
              <el-table-column prop="Quantity" label="本次入库分配数" min-width="120px" align="right">
                <template slot-scope="{row}">
                  <span >{{row.Quantity}}</span>
                  <!-- <el-input-number v-else v-model="row.Quantity" :controls="false" style="width:100px" /> -->
                </template>
              </el-table-column>
              <el-table-column prop="DocDate" label="分配时间" min-width="160px" />
              <el-table-column prop="WarehouseName" label="入库仓库" min-width="120px" />
              <el-table-column prop="UnStockInQuantity" label="操作" min-width="120px" align="center" >
                <template slot-scope="{row}">
                  <el-button type="text" @click="onSaved(row)" v-if="!row.DocProductId">保存</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column prop="TradeUnitName" label="供应商" min-width="120px"  />
        <el-table-column prop="WarehouseName" label="仓库" min-width="120px"  />
        <el-table-column prop="ProductNo" label="存货编码" min-width="120px" />
        <el-table-column prop="ProductName" label="存货名称" min-width="120px" />
        <el-table-column prop="ProcessingType" label="规格型号" min-width="120px"  />
        <el-table-column prop="ProductSpec" label="属性" min-width="120px"  />
        <el-table-column prop="ColorName" label="颜色" min-width="120px"  />
        <el-table-column prop="Quantity" label="数量" min-width="120px"  />
        <el-table-column prop="AllocationQuantity" label="已分配数量" min-width="120px" align="right"/>
        <el-table-column prop="UnitName" label="单位" min-width="120px"  />
        <el-table-column prop="MakeEmpName" label="制单人" min-width="120px"  />
        <el-table-column prop="DocDate" label="时间" min-width="120px"  />
        <el-table-column prop="Status" label="状态" min-width="80px" >
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">未处理</span>
            <span v-else-if="row.Status == 2">已处理</span>
          </template>
        </el-table-column>
        <el-table-column prop="UnStockInQuantity" label="操作" min-width="120px" align="center" fixed="right">
          <template slot-scope="{row,$index}">
            <el-button type="text" @click="onDispose(row,$index)">{{ row.Status == 2 ? '取消' : '处理'}}</el-button>
            <el-button type="text" @click="openPage(row,$index)" v-if="row.Status != 2">添加</el-button>
            </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- <order-dialog ref="orderDialog" @saved="saved" :ProductId="ProductId"></order-dialog> -->
    <emptor-select ref="emptorDialog" in-dialog selectable multiple :ProductId="ProductId" @select-multiple="setOrderList($event)" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
// import orderDialog from "./orderDialog/orderDialog";
import emptorSelect from "@/components/business/stock/productionreport/emtorSelect/listDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    // orderDialog,
    emptorSelect
  },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/stock/stInDocLog").default,
      productInDtsApi: require("@/api/st/productInDts").default,
      stInDocApi: require("@/api/stock/stInDoc").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      in_api: require("@/api/st/productInDts").default,
      params: {
        InType: 10,
        ProcessingType: null,
        DocDateStart:null,
        DocDateEnd:null,
        ProductName: null,
        MakeEmpName: null,
        Status: null,
        TradeUnitId:null,
        TradeUnitName: null,
      },
      machiningStageList: [],
      tradeUnitList: [],
      dataIndex: null,//表格数据索引
      ProductId:0 //表格行的存货id
    };
  },
  created() {
    this.getMachiningStageList()
    this.gettradeUnitList()
  },
  methods: {
    getMachiningStageList() {
      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        this.machiningStageList = []
        res.Data.forEach((item) => {
          this.machiningStageList.unshift({ value: item.Name, label: item.Name });
        })
      });
    },
    gettradeUnitList() {
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3], Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data.map((item) => {
            return {
              key: item.TradeUnitId,
              label: item.FullName,
              value: item.TradeUnitId,
            };
          });
        }
      });
    },
    
    changeTradeUnit(val) {
      let item = this.tradeUnitList.filter((item) => {
        return val === item.key;
      })[0];
      this.params.TradeUnitName = item.label;
    },
    resetQuery() {
      this.params.OrderProductNo = "";
      this.params.ProductName = "";
      this.params.ShowType = null;
      this.params.FinishDateStart = this.$commonJs.getToday();
      this.params.FinishDateEnd = this.$commonJs.getToday();
      this.params.OrderProductNo = "";
      this.params.Status = null;
      this.mode = null;
      this.$refs.list.getData();
    },
    expandChange({ currentRow }) {
      let DocProductId = currentRow.DocProductId;
      const o = {
        DocProductLogId: DocProductId
      }
      this.productInDtsApi.GetPuDtoInfo(DocProductId).then((res) => {
        if (res.Code === 0) {
          let data = JSON.parse(JSON.stringify(res.Data));
          currentRow.listData = data;
        }
      });
    },
    resetDataFunc(data) {
      data.forEach((item) => {
        item.tabsView = "tabsView1";
        item.listData = [];
        item.imageData = [];
        console.log("item", item);
      });
      console.log("data", data);
      this.$refs.list.setExpands([]);
      return data;
    },
    async openPage(row,index) {
      this.dataIndex = index
      this.ProductId = row.ProductId

      const res = await this.sourceTypeApi.info("采购入库单");
      let OrderType = res.SourceTypeId;
      let that = await this.$refs.emptorDialog.open();
      that.getData({
        TradeUnitName:row.TradeUnitName,
        Status: 2,
        LineAbort: false,
        OrderType 
      });
    },
    onDispose(row,index){
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const ids = [row.DocId]
        this.api.UpdateStatus(ids).then(res => {
          if (res.Code == 0) {
            this.$message.success("操作成功");
            this.$refs.list.getData();
          } else {
            this.$message.warning(res.Msg);
          }
        })
      });
    },
    // saved(selRow){
    //   const o = {
    //     DocDate: selRow[0].DocDate,
    //     WorkDocNo: selRow[0].WorkDocNo,
    //     WorkDocId: selRow[0].WorkDocId,
    //     AnswerQuantity: selRow[0].Quantity,
    //     InCompleteQuantity: selRow[0].UnQuantity,
    //   }
    //   this.$refs.list.data[this.dataIndex].listData.push(o)
    // },
    setOrderList(data){
      const o = {
        PuDocDate: data.List[0].DocDate,
        SourceNo: data.Order,
        TradeUnitId: data.TradeUnitId,
        TradeUnitName: data.TradeUnitName,
        ProductNo: data.List[0].ProductNo,
        ProductName: data.List[0].ProductName,
        PuDocQuantity: data.List[0].PurchaseQuantity + (data.List[0].PuDocOccupyQuantity ?? 0) + (data.List[0].StInDocOccupyQuantity ?? 0),
        WaitPuDocQuantity: data.List[0].PurchaseQuantity,
        Quantity: this.$refs.list.data[this.dataIndex].Quantity - this.$refs.list.data[this.dataIndex].AllocationQuantity,
        DocProductLogId:this.$refs.list.data[this.dataIndex].DocProductId,
        SourceId: data.List[0].OrderId,
        SourceDtsId: data.List[0].OrderProductId,
      }
      this.$refs.list.data[this.dataIndex].listData.push(o)
    },  
    onSaved(row){
      const params = {
        DocProductLogId:this.$refs.list.data[this.dataIndex].DocProductId,
        SourceId:row.SourceId,
        SourceDtsId:row.SourceDtsId,
        SourceNo:row.SourceNo
      }
      this.stInDocApi.PdaPuSave(params).then(res => {
        if (res.Code == 0) {
          this.$message.success("保存成功");
        } else {
          this.$message.warning(res.Msg);
        }
        this.$refs.list.getData();
      })
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
